import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { appTheme } from './theme'
import Router from './routes/Router'
import { authPersistenceReady } from './firebase'

function AppWithAuthReady() {
  const [ready, setReady] = useState(false)
  useEffect(() => {
    authPersistenceReady.then(() => setReady(true))
  }, [])
  if (!ready) return null
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <AppWithAuthReady />
    </ThemeProvider>
  </React.StrictMode>
)
